class Tabs {
    constructor(tabContainer) {
        this.tabContainer = tabContainer;
        this.tabLinks     = this.tabContainer.querySelectorAll('[data-tab="button"]');
        this.tabContent   = this.tabContainer.querySelectorAll('[data-tab="content"]');
        this.tabSubLinks     = this.tabContainer.querySelectorAll('[data-sub-tab="button"]');

        this.tabLinks.forEach((el) => {
            el.addEventListener('click', (e) => this.openTabs(e));
        });
    }

    openTabs(el) {
        const btnTarget = el.currentTarget;
        const item = btnTarget.dataset.id;

        this.tabContent.forEach((el) => {
            el.classList.remove('is-active');
        });

        this.tabLinks.forEach((el) => {
            el.classList.remove('is-active');
        });

        this.tabContainer.querySelector(`${item}`).classList.add('is-active');
        btnTarget.classList.add('is-active');

    }

}

export default Tabs;
